export default "__VITE_ASSET__TW5q_iLW__"